import { AJOUTER_COMPTE_TITRES } from './actionTypes'

export const ajouterCompteTitres = (compteTitres) => {
	return ({
		type: AJOUTER_COMPTE_TITRES,
		payload: compteTitres
	})
}
